/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import Tooltip from '@mui/material/Tooltip';
import TooltipComponent from './TooltipComponent';
import styled from 'styled-components';

const CustomTooltip = ({ content, text, style, isOpen }) => {
  return (
    <MyTooltip title={text} arrow={true} placement='top' open={isOpen}>
      <TooltipComponent style={style} render={content} />
    </MyTooltip>
  );
};

export default CustomTooltip;

const MyTooltip = styled(Tooltip)``;

export const CustomTooltip2 = ({ content, text, style, isOpen }) => {
  const [hovered, setHovered] = useState(false);

  const [position, setPosition] = useState({ top: 0, left: 0 });
  const targetRef = useRef(null);
  const tooltipRef = useRef(null);

  const showTooltip = isOpen ?? hovered;

  useEffect(() => {
    if (!showTooltip || !targetRef.current) return;
    const rect = targetRef.current.getBoundingClientRect();
    const tooltipRect = tooltipRef.current.getBoundingClientRect();
    setPosition({
      top: rect.top - tooltipRect.height - 10,
      left: rect.left + rect.width * 0.25,
    });
    tooltipRef.current.style.opacity = 1;
  }, [showTooltip]);

  return (
    <>
      <TooltipWrapper
        ref={targetRef}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={style}
      >
        {content}
      </TooltipWrapper>
      {showTooltip &&
        ReactDOM.createPortal(
          <TooltipBox
            ref={tooltipRef}
            style={{ top: `${position.top}px`, left: `${position.left}px` }}
          >
            {text}
          </TooltipBox>,
          document.body,
        )}
    </>
  );
};

const TooltipWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
`;

const TooltipBox = styled.div`
  position: fixed;
  background: white;
  padding: 6px 10px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  z-index: 9999;
  opacity: 0;
  transition: opacity 0.2s ease, visibility 0.2s ease;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
  transform: translateX(-50%);

  &::after {
    content: '';
    position: absolute;
    bottom: -11px;
    left: 52%;
    border-width: 6px;
    border-style: solid;
    border-color: white transparent transparent transparent;
  }
`;
